import { Platform, StyleSheet } from 'react-native';

import { COLOR } from 'utils/colors';
import {
    heightPercentageToDP,
    isTablet,
    isWeb,
    widthPercentageToDP,
} from 'utils/responsiveness';

const styles = StyleSheet.create({
    root: {
        height: isWeb ? 40 : heightPercentageToDP(24),
        paddingHorizontal: Platform.select({
            web: widthPercentageToDP(72),
            default: widthPercentageToDP(16, 44),
        }),
    },
    datePickerContainer: {
        width: 'auto',
    },
    filterPickerContainer: {
        width: 'auto',
    },
    pickerContainer: {
        flex: 1,
        justifyContent: isTablet ? 'space-between' : 'flex-start',
    },
    layoutButtonsContainer: {
        backgroundColor: COLOR.COD_GRAY_LIGHT,
        borderRadius: 40,
        height: isWeb ? 40 : heightPercentageToDP(40),
    },
    layoutButton: {
        width: isWeb ? 40 : widthPercentageToDP(40),
    },
});

export default styles;
